/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { SuccessResponseDTOListTfxPublishedDTO, SuccessResponseDTOVoid } from '.././model';

import { customInstance } from '../../http';

/**
 * @summary DELISTED to ACTIVE and rebuild the catalog.
 */
export const relistTfxPublished = (packageId: string) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/tfx/published/${packageId}/relist`,
    method: 'PATCH',
  });
};

export const getRelistTfxPublishedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof relistTfxPublished>>,
    TError,
    { packageId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof relistTfxPublished>>,
  TError,
  { packageId: string },
  TContext
> => {
  const mutationKey = ['relistTfxPublished'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof relistTfxPublished>>,
    { packageId: string }
  > = (props) => {
    const { packageId } = props ?? {};

    return relistTfxPublished(packageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RelistTfxPublishedMutationResult = NonNullable<
  Awaited<ReturnType<typeof relistTfxPublished>>
>;

export type RelistTfxPublishedMutationError = unknown;

/**
 * @summary DELISTED to ACTIVE and rebuild the catalog.
 */
export const useRelistTfxPublished = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof relistTfxPublished>>,
      TError,
      { packageId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof relistTfxPublished>>,
  TError,
  { packageId: string },
  TContext
> => {
  const mutationOptions = getRelistTfxPublishedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Kill switch: ACTIVE to DELISTED and rebuild the catalog.
 */
export const delistTfxPublished = (packageId: string) => {
  return customInstance<SuccessResponseDTOVoid>({
    url: `/admin/api/tfx/published/${packageId}/delist`,
    method: 'PATCH',
  });
};

export const getDelistTfxPublishedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof delistTfxPublished>>,
    TError,
    { packageId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof delistTfxPublished>>,
  TError,
  { packageId: string },
  TContext
> => {
  const mutationKey = ['delistTfxPublished'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof delistTfxPublished>>,
    { packageId: string }
  > = (props) => {
    const { packageId } = props ?? {};

    return delistTfxPublished(packageId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DelistTfxPublishedMutationResult = NonNullable<
  Awaited<ReturnType<typeof delistTfxPublished>>
>;

export type DelistTfxPublishedMutationError = unknown;

/**
 * @summary Kill switch: ACTIVE to DELISTED and rebuild the catalog.
 */
export const useDelistTfxPublished = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof delistTfxPublished>>,
      TError,
      { packageId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof delistTfxPublished>>,
  TError,
  { packageId: string },
  TContext
> => {
  const mutationOptions = getDelistTfxPublishedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary All published packages (ACTIVE and DELISTED).
 */
export const listTfxPublished = (signal?: AbortSignal) => {
  return customInstance<SuccessResponseDTOListTfxPublishedDTO>({
    url: `/admin/api/tfx/published`,
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
};

export const getListTfxPublishedQueryKey = () => {
  return [`/admin/api/tfx/published`] as const;
};

export const getListTfxPublishedQueryOptions = <
  TData = Awaited<ReturnType<typeof listTfxPublished>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxPublished>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTfxPublishedQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTfxPublished>>> = ({ signal }) =>
    listTfxPublished(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTfxPublished>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTfxPublishedQueryResult = NonNullable<Awaited<ReturnType<typeof listTfxPublished>>>;
export type ListTfxPublishedQueryError = unknown;

export function useListTfxPublished<
  TData = Awaited<ReturnType<typeof listTfxPublished>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxPublished>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTfxPublished>>,
          TError,
          Awaited<ReturnType<typeof listTfxPublished>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTfxPublished<
  TData = Awaited<ReturnType<typeof listTfxPublished>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxPublished>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTfxPublished>>,
          TError,
          Awaited<ReturnType<typeof listTfxPublished>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTfxPublished<
  TData = Awaited<ReturnType<typeof listTfxPublished>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxPublished>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary All published packages (ACTIVE and DELISTED).
 */

export function useListTfxPublished<
  TData = Awaited<ReturnType<typeof listTfxPublished>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listTfxPublished>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListTfxPublishedQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
